"use strict";

import App from "system/app";
import "theme/layout";

// routed modules
import "@expressive-analytics/vue-login";

// styles
import "@expressive-analytics/skin-ea-basic";
//import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue/dist/bootstrap-vue.css";
import "css";

// make sure that all routed modules are loaded before calling init()
// i.e. if your route contains "use:", load it above
App.init();

import Vue from "vue";
Vue.config.productionTip = false; // stop being annoying

import moment from "moment";
Vue.filter("date", (val, fmt) => {
  return moment(val).format(fmt);
});

Vue.filter("eachKey", (val, key) => {
  return val
    .map(a => {
      return a[key];
    })
    .join(", ");
});

import VueSelect from "vue-select";
Vue.component("v-select", VueSelect);
import "vue-select/src/scss/vue-select.scss";

import VueSocialSharing from "vue-social-sharing"
Vue.use(VueSocialSharing);
